import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrgGuestFeedbackIntegrationFragment = { __typename?: 'OrgGuestFeedbackIntegration', id: string, enabled: boolean, googleBusinessConfig?: { __typename?: 'OrgGuestFeedbackGoogleBusinessConfig', id: string, accountId: string } | null, locationGroup?: { __typename?: 'LocationGroup', id: string, name: string } | null, ovationIntegrationConfig?: { __typename?: 'OrgGuestFeedbackOvationIntegrationConfig', id: string, companyId: string } | null, tattleIntegrationConfig?: { __typename?: 'OrgGuestFeedbackTattleIntegrationConfig', id: string, merchantId: string } | null, locations: Array<{ __typename?: 'OrgGuestFeedbackIntegrationLocation', id: string, sourceLocationId: string, sourceName?: string | null, location?: { __typename?: 'Location', id: number, name: string } | null }> };

export type OrgGuestFeedbackIntegrationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrgGuestFeedbackIntegrationsQuery = { __typename?: 'Query', OrgGuestFeedbackIntegrations: Array<{ __typename?: 'OrgGuestFeedbackIntegration', id: string, enabled: boolean, googleBusinessConfig?: { __typename?: 'OrgGuestFeedbackGoogleBusinessConfig', id: string, accountId: string } | null, locationGroup?: { __typename?: 'LocationGroup', id: string, name: string } | null, ovationIntegrationConfig?: { __typename?: 'OrgGuestFeedbackOvationIntegrationConfig', id: string, companyId: string } | null, tattleIntegrationConfig?: { __typename?: 'OrgGuestFeedbackTattleIntegrationConfig', id: string, merchantId: string } | null, locations: Array<{ __typename?: 'OrgGuestFeedbackIntegrationLocation', id: string, sourceLocationId: string, sourceName?: string | null, location?: { __typename?: 'Location', id: number, name: string } | null }> }> };

export type UpdateOrgGuestFeedbackIntegrationMutationVariables = Types.Exact<{
  input: Types.UpdateOrgGuestFeedbackIntegrationInput;
}>;


export type UpdateOrgGuestFeedbackIntegrationMutation = { __typename?: 'Mutation', updateOrgGuestFeedbackIntegration: { __typename?: 'OrgGuestFeedbackIntegrationMutationResult', success: boolean, error?: { __typename?: 'Error', message?: string | null } | null, orgGuestFeedbackIntegration?: { __typename?: 'OrgGuestFeedbackIntegration', id: string, enabled: boolean } | null } };

export type DeleteOrgGuestFeedbackIntegrationMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type DeleteOrgGuestFeedbackIntegrationMutation = { __typename?: 'Mutation', deleteOrgGuestFeedbackIntegration: { __typename?: 'BaseMutationResult', success: boolean, error?: { __typename?: 'Error', message?: string | null } | null } };

export const OrgGuestFeedbackIntegrationFragmentDoc = gql`
    fragment OrgGuestFeedbackIntegration on OrgGuestFeedbackIntegration {
  id
  enabled
  googleBusinessConfig {
    id
    accountId
  }
  locationGroup {
    id
    name
  }
  ovationIntegrationConfig {
    id
    companyId
  }
  tattleIntegrationConfig {
    id
    merchantId
  }
  locations {
    id
    sourceLocationId
    sourceName
    location {
      id
      name
    }
  }
}
    `;
export const OrgGuestFeedbackIntegrationsDocument = gql`
    query OrgGuestFeedbackIntegrations {
  OrgGuestFeedbackIntegrations {
    ...OrgGuestFeedbackIntegration
  }
}
    ${OrgGuestFeedbackIntegrationFragmentDoc}`;

/**
 * __useOrgGuestFeedbackIntegrationsQuery__
 *
 * To run a query within a React component, call `useOrgGuestFeedbackIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgGuestFeedbackIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgGuestFeedbackIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgGuestFeedbackIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<OrgGuestFeedbackIntegrationsQuery, OrgGuestFeedbackIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgGuestFeedbackIntegrationsQuery, OrgGuestFeedbackIntegrationsQueryVariables>(OrgGuestFeedbackIntegrationsDocument, options);
      }
export function useOrgGuestFeedbackIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgGuestFeedbackIntegrationsQuery, OrgGuestFeedbackIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgGuestFeedbackIntegrationsQuery, OrgGuestFeedbackIntegrationsQueryVariables>(OrgGuestFeedbackIntegrationsDocument, options);
        }
export type OrgGuestFeedbackIntegrationsQueryHookResult = ReturnType<typeof useOrgGuestFeedbackIntegrationsQuery>;
export type OrgGuestFeedbackIntegrationsLazyQueryHookResult = ReturnType<typeof useOrgGuestFeedbackIntegrationsLazyQuery>;
export type OrgGuestFeedbackIntegrationsQueryResult = Apollo.QueryResult<OrgGuestFeedbackIntegrationsQuery, OrgGuestFeedbackIntegrationsQueryVariables>;
export const UpdateOrgGuestFeedbackIntegrationDocument = gql`
    mutation UpdateOrgGuestFeedbackIntegration($input: UpdateOrgGuestFeedbackIntegrationInput!) {
  updateOrgGuestFeedbackIntegration(input: $input) {
    success
    error {
      message
    }
    orgGuestFeedbackIntegration {
      id
      enabled
    }
  }
}
    `;
export type UpdateOrgGuestFeedbackIntegrationMutationFn = Apollo.MutationFunction<UpdateOrgGuestFeedbackIntegrationMutation, UpdateOrgGuestFeedbackIntegrationMutationVariables>;

/**
 * __useUpdateOrgGuestFeedbackIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateOrgGuestFeedbackIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrgGuestFeedbackIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrgGuestFeedbackIntegrationMutation, { data, loading, error }] = useUpdateOrgGuestFeedbackIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrgGuestFeedbackIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrgGuestFeedbackIntegrationMutation, UpdateOrgGuestFeedbackIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrgGuestFeedbackIntegrationMutation, UpdateOrgGuestFeedbackIntegrationMutationVariables>(UpdateOrgGuestFeedbackIntegrationDocument, options);
      }
export type UpdateOrgGuestFeedbackIntegrationMutationHookResult = ReturnType<typeof useUpdateOrgGuestFeedbackIntegrationMutation>;
export type UpdateOrgGuestFeedbackIntegrationMutationResult = Apollo.MutationResult<UpdateOrgGuestFeedbackIntegrationMutation>;
export type UpdateOrgGuestFeedbackIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateOrgGuestFeedbackIntegrationMutation, UpdateOrgGuestFeedbackIntegrationMutationVariables>;
export const DeleteOrgGuestFeedbackIntegrationDocument = gql`
    mutation DeleteOrgGuestFeedbackIntegration($id: UUID!) {
  deleteOrgGuestFeedbackIntegration(id: $id) {
    success
    error {
      message
    }
  }
}
    `;
export type DeleteOrgGuestFeedbackIntegrationMutationFn = Apollo.MutationFunction<DeleteOrgGuestFeedbackIntegrationMutation, DeleteOrgGuestFeedbackIntegrationMutationVariables>;

/**
 * __useDeleteOrgGuestFeedbackIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteOrgGuestFeedbackIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrgGuestFeedbackIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrgGuestFeedbackIntegrationMutation, { data, loading, error }] = useDeleteOrgGuestFeedbackIntegrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrgGuestFeedbackIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrgGuestFeedbackIntegrationMutation, DeleteOrgGuestFeedbackIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrgGuestFeedbackIntegrationMutation, DeleteOrgGuestFeedbackIntegrationMutationVariables>(DeleteOrgGuestFeedbackIntegrationDocument, options);
      }
export type DeleteOrgGuestFeedbackIntegrationMutationHookResult = ReturnType<typeof useDeleteOrgGuestFeedbackIntegrationMutation>;
export type DeleteOrgGuestFeedbackIntegrationMutationResult = Apollo.MutationResult<DeleteOrgGuestFeedbackIntegrationMutation>;
export type DeleteOrgGuestFeedbackIntegrationMutationOptions = Apollo.BaseMutationOptions<DeleteOrgGuestFeedbackIntegrationMutation, DeleteOrgGuestFeedbackIntegrationMutationVariables>;